export enum FlyoutSearchView {
  Desktop = 'desktop',
  Mobile = 'mobile'
}
